module.exports = __webpack_public_path__ + "ni.svg?7d565588aac2f39d1fcada1bf11de5ca";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ni.svg
// module id = 898
// module chunks = 27